import { fattribs, ff } from "./format";
export const rect = (p, width, height, attribs, ...body) => roundedRect(p, width, height, 0, 0, attribs, ...body);
export const roundedRect = (p, width, height, rx, ry, attribs, ...body) => {
    attribs = fattribs(Object.assign(Object.assign({}, attribs), { x: ff(p[0]), y: ff(p[1]), width: ff(width), height: ff(height) }));
    if (rx > 0 || ry > 0) {
        attribs.rx = ff(rx);
        attribs.ry = ff(ry);
    }
    return ["rect", attribs, ...body];
};
